<template>
    <div id="demo-basic-card">
        <div class="vx-row h-100">
            <div class="vx-col w-full sm:w-1/2 md:w-1/3 mb-base" v-for="item in services" :key="item.id">
                <vx-card>
                    <div slot="no-body">
                        <img
                                :src="require(`@/assets/images/pages/my-service/${item.image}`)"
                                alt="content-img"
                                class="responsive card-img-top"
                        />
                    </div>
                    <h5 class="mb-2">{{ item.title }}</h5>
                    <p class="text-grey">{{ item.description }}</p>
                    <div class="flex justify-between flex-wrap">
                        <vs-button
                                v-bind:id="'btn-service-'+item.id"
                                class="mt-4 shadow-lg"
                                type="gradient"
                                color="#7367F0"
                                gradient-color-secondary="#CE9FFC"
                                v-on:click="comingSoon(item.title, item.url)"
                        >Manage {{item.title}}
                        </vs-button>
                    </div>
                </vx-card>
            </div>
        </div>
    </div>
</template>

<script>
    import VuePerfectScrollbar from "vue-perfect-scrollbar";
    import ServiceAPI from "@/network/api/ServiceAPI";
    import swal from "sweetalert2";

    export default {
        data() {
            return {
                services: [
                    {
                        id: 1,
                        image: "tourism.png",
                        title: "Tourism & Transport",
                        description:
                            "Allows merchant to create ticket and manage fare which applicable for tourism and transport business",
                        url: "/"
                    },
                    {
                        id: 2,
                        image: "payment.png",
                        title: "Payment",
                        description:
                            "Enjoy our free hasle payment service to treat your customer with better payment experience",
                        url: "/"
                    },
                    {
                        id: 3,
                        image: "retail.jpg",
                        title: "Retail",
                        description: "Boost your transaction with our best service",
                        url: "/"
                    },
                    {
                        id: 4,
                        image: "consumer.png",
                        title: "Consumer",
                        description:
                            "Treat your customer very well with our customer loyatly service",
                        url: "/"
                    }
                ]
            };
        },
        components: {
            VuePerfectScrollbar,
        },
        methods: {
          comingSoon(title, url) {
            if (url=='#') {
                swal.fire({
                  imageUrl: 'coming-soon.png',
                  imageHeight: 150,
                  // type: 'info',
                  title: 'Coming Soon',
                  text: title,
                  allowOutsideClick: false,
                })
            }else {
                this.$store.dispatch('createAuditTrail', {
                    user_id:    JSON.parse(localStorage.getItem('userInfo')).id,
                    session_id: parseInt(localStorage.getItem('sessID')),
                    user_name:  JSON.parse(localStorage.getItem('userInfo')).displayName,
                    menu:      "Services",
                    activity: "Redirect to "+ title + " service",
                }).then(() => {
                     window.location.href = url
                }, () => {
                    window.location.href = url
                }) 
            }
          }
        },
        mounted() {
            ServiceAPI.ListAll().then((result => {
                this.services = []
                for (let service of result.data) {
                    this.services.push(service)
                }
            }))
        }
    };
</script>

<style lang="scss">
    .vx-card__body {
        p {
            min-height: 60px;
        }
    }

    #demo-basic-card {
        .overlay-card {
            .vx-card__collapsible-content {
                max-height: 485px;
            }
        }

        .chat-card-log {
            height: 360px;

            .chat-sent-msg {
                background-color: #f2f4f7 !important;
            }
        }
    }
</style>